import React from "react";
import { Outlet } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";

const OrgManagementLayout = (): React.JSX.Element => {
    return (
        <Container
            className="py-5 orgManagement"
            data-testid="orgManagementContent"
        >
            <Row>
                <Col>
                    <Outlet />
                </Col>
            </Row>
        </Container>
    );
};

export default OrgManagementLayout;
